import React, { PureComponent } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { actions } from "../../store";
import { connect } from "react-redux";



class BroadcastDialog extends PureComponent {

	handleClose = () => {
		this.props.setLayout({
			broadcastOpen: false,
		});
	};


	render() {
		const { title, text, open } = this.props;

		return (
			<Dialog
				open={open}
				onClose={this.handleClose}
			>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<DialogContentText style={{whiteSpace: 'pre-wrap'}}>
						{text}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={this.handleClose}
						color="primary"
						autoFocus
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}



const mapStateToProps = state => {
	return {
		title: state.layout.broadcastTitle,
		text: state.layout.broadcastText,
		open: state.layout.broadcastOpen,
	}
};


const mapDispatchToProps = dispatch => {
	return {
		setLayout: (data) => {
			dispatch(actions.layout.setState(data));
		},
	}
};


export default connect(mapStateToProps, mapDispatchToProps)(BroadcastDialog);